import React from 'react';
import { MobxComponent } from "../../../mobx/components";
import { inject, observer } from "mobx-react";
import { withTranslation, WithTranslation } from "react-i18next";
import { IconSettings, IconClose } from "../../components/v2/icons";
import { Input, Switch } from "@lib/components";
import { HeaderTitleWrapper, MenuItem, QuickSettingsContainer, QuickSettingsHeaderWrapper, QuickSettingsBodyWrapper, QuickSettingsFooterWrapper, QuickSettingsButton, QuickSettingsItemsContainer, QuickSettingsItemsWrapper, QuickSettingsItemWrapper } from "./layout.c";
import { syncDashboardLocalize, effectiveTranslationProvider, TranslationProvider } from '../../../core/localize-dashboard';
import { UI } from '../../../core/ui';


interface Props extends WithTranslation {}
interface State {
    translation_api_key: string;
    translation_provider: TranslationProvider;
}

@inject("store") @observer
class QuickSettingsClass extends MobxComponent<Props, State> {
    constructor(props: Props) {
		super(props);
        this.state = {
            translation_api_key: '',
            translation_provider: 'polyglot',
        };
	}

    componentDidMount(): void {
        const { organisation } = this.injected.store
        this.setState({
            translation_api_key: organisation!.translation_api_key || '',
            translation_provider: effectiveTranslationProvider(organisation),
        })
    }
    

    render() {
        const { store, t} = this.injected;
        const { organisation } = store;
        if(!organisation) return
        return (
        <QuickSettingsContainer className={store.view.quicksettings_active ? 'active': ''}>
            <QuickSettingsHeaderWrapper>
                <HeaderTitleWrapper>
                    <IconSettings />
                    <div>Quick Settings</div>
                </HeaderTitleWrapper>
                <MenuItem onClick={() => store.updateView({quicksettings_active: false})}><IconClose /></MenuItem>
            </QuickSettingsHeaderWrapper>
            <QuickSettingsBodyWrapper>
                <QuickSettingsItemsContainer style={{flexDirection: 'column', alignItems: 'start'}}>
                    <QuickSettingsItemsWrapper>
                        <QuickSettingsItemWrapper>
                            <span>Use Modern Layout</span>
                            <Switch
                            id="switch-layout"
                            checked={organisation.dashboard ? organisation.dashboard == 'v2': false}
                            onChange={(e) => {
                                store.updateOrganisation({
                                    dashboard: e.target.checked ?  'v2' : 'v1'
                                })
    
                             
                            }} />
                        </QuickSettingsItemWrapper>
                        <p>Ordering dashboard is currently using the classic layout.</p>
                    </QuickSettingsItemsWrapper>
                    <QuickSettingsItemsWrapper>
                        <QuickSettingsItemWrapper style={{flexDirection: 'column', alignItems: 'start'}}>
                            <span>Translation Provider</span>
                            <select
                                value={this.state.translation_provider}
                                onChange={(e) => {
                                    this.setState({
                                        translation_provider: e.target.value as TranslationProvider,
                                    });
                                }}
                            >
                                <option value="polyglot">Polyglot</option>
                                <option value="localize">LocalizeJS</option>
                            </select>
                        </QuickSettingsItemWrapper>
                        <p>
                            {t('translationProviderHelp', {
                                defaultValue: 'Choose which translation service powers the admin dashboard UI. Polyglot is the default.'
                            })}
                        </p>
                    </QuickSettingsItemsWrapper>
                    {this.state.translation_provider === 'localize' && (
                    <QuickSettingsItemsWrapper>
                        <QuickSettingsItemWrapper style={{flexDirection: 'column', alignItems: 'start'}}>
                            <span>Translation API Key (optional)</span>
                            <Input
                                type="password"
                                autoComplete="off"
                                spellCheck={false}
                                value={this.state.translation_api_key}
                                onChange={(e) => {
                                    this.setState({
                                        translation_api_key: e.target.value
                                    })
                                }}
                            />
                        </QuickSettingsItemWrapper>
                        <p>
                            {t('localizeKeyHelp', {
                                defaultValue: 'Key used to translate the admin dashboard UI. Only set this if you have your own LocalizeJS project key.'
                            })}
                        </p>
                    </QuickSettingsItemsWrapper>
                    )}
                </QuickSettingsItemsContainer>
            </QuickSettingsBodyWrapper>
            <QuickSettingsFooterWrapper>
                <QuickSettingsButton 
                    onClick={() => {
                        store.updateView({quicksettings_active: false})
                        const translationKey = this.state.translation_api_key.trim();
                        const translationProvider = this.state.translation_provider;
                        store.updateOrganisation({
                            translation_api_key: translationKey.length > 0 ? translationKey : '',
                            translation_provider: translationProvider,
                        })
                        store.api.organisation_update({
                            _id: organisation._id,
                            update: {
                                $set: {
                                    translation_api_key: translationKey,
                                    translation_provider: translationProvider,
                                    dashboard: organisation.dashboard
                                }
                            }
                        }).then(() => {
                            UI.notification.success("Settings updated");
                            syncDashboardLocalize(store.reseller, store.organisation);
                        })
                    }}>
                    Save Settings
                </QuickSettingsButton>
            </QuickSettingsFooterWrapper>
        </QuickSettingsContainer>
        )
    }
}
export const QuickSettings = withTranslation()(QuickSettingsClass);
